import { render, staticRenderFns } from "./TBank.vue?vue&type=template&id=3d0046ea&scoped=true&"
import script from "./TBank.vue?vue&type=script&lang=js&"
export * from "./TBank.vue?vue&type=script&lang=js&"
import style0 from "./TBank.vue?vue&type=style&index=0&id=3d0046ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0046ea",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSpinner,QIcon});
